/**
 * @module byo-bundle/celebrate
 * Decorative motion: the counter roll. Text-preserving and skipped under reduced motion.
 */

/** True when motion should be skipped: reduced motion, or no matchMedia (tests). */
export function reducedMotion() {
  return (
    typeof window.matchMedia !== 'function' ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}

/** Rolls `el`'s number from `from` to `to`, upwards for a rise and downwards for a drop. */
export function roll(el: HTMLElement | null, from: number, to: number) {
  if (!el || from === to || reducedMotion() || typeof el.animate !== 'function') return;
  const up = to > from;
  const reel = document.createElement('span');
  reel.className = 'byo-bundle__roll';
  for (const n of up ? [from, to] : [to, from]) {
    reel.append(Object.assign(document.createElement('span'), { textContent: String(n) }));
  }
  el.replaceChildren(reel);
  const end = 'translateY(-50%)';
  reel.animate([{ transform: up ? 'none' : end }, { transform: up ? end : 'none' }], {
    duration: 380,
    easing: 'cubic-bezier(0.34, 1.56, 0.64, 1)',
    fill: 'forwards',
  }).onfinish = () => {
    // A newer roll has already replaced this reel.
    if (reel.isConnected) el.textContent = String(to);
  };
}
